import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../../styles/diario.scss';

const Veiculo = (props) => {

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchVeiculos()
    }

    const editar = async (id) => {
        props.editar(id)
    }
    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Header><h5>{props.veiculo.modelo} / {props.veiculo.marca}</h5></Card.Header>
                    <Card.Body>
                        <p>Secretaria: {props.veiculo.secretaria}</p>
                        <p>Placa: {props.veiculo.placa}</p>
                        <p>Finalidade: {props.veiculo.finalidade}</p>
                        <p>Tipo: {props.veiculo.tipo}</p>
                        <p>Situação: {props.veiculo.situacao}</p>
                        <p>Categoria: {props.veiculo.categoria}</p>
                        <p>Proprietário: {props.veiculo.proprietario}</p>
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.veiculo._id)} variant='primary'>Editar</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.veiculo._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Veiculo;